import { useEffect } from 'react';

export function useTrackCalculatorLoad(name: string, amount = 0) {
  useEffect(() => {
    if (window.DB && window.DB.trackCalculatorLoad) {
      // eslint-disable-next-line camelcase
      window.DB.trackCalculatorLoad({ calculator_type: 'housing', calculator_name: name, calculator_amount: amount });
    }
  }, []);
}

export function trackCalculatorSubmit(amount?: string, info?: string) {
  if (window.DB && window.DB.trackCalculatorSubmit) {
    window.DB.trackCalculatorSubmit(amount, info);
  }
}

export function trackCalculatorInit() {
  if (window.DB && window.DB.trackCalculatorInit) {
    window.DB.trackCalculatorInit();
  }
}

export function track(id: string) {
  if (window.DB && window.DB.track) {
    window.DB.track(id);
  }
}
